// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XhX1","colMin":"styles_colMin__s6fW7"};